import { render, staticRenderFns } from "./VDAControl.reg.vue?vue&type=template&id=7340f108&"
import script from "./VDAControl.reg.vue?vue&type=script&lang=ts&"
export * from "./VDAControl.reg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports